<form name="viewPoform">
  <div class="row">
     <div class="col-sm-10"> 
    <table class="table table-bordered" name="table" id="table" cellspacing="0px" cellpadding="0px">
        <tr>
                <td class="center-align" colspan="3"><strong class="potitle">City Installation Report</strong></td>
              </tr>
              <tr>
                <td >Cutomer PO ref no.: {{cityAssets.poreferenceno}} </td> 
                <td >PO NO.: {{cityAssets.pono}}</td> 
                <td *ngIf="cityAssets.podate > 0"> PO Dated : {{cityAssets.podate| date:'dd-MM-yyyy'}}</td>
                <td *ngIf="cityAssets.podate == 0"> PO Dated : </td>
              </tr>
              <tr>
                <td colspan="2">Customer Department : {{cityAssets.customerdepartment}}</td>
                <td *ngIf="cityAssets.installationdate > 0">Date : {{cityAssets.installationdate| date:'dd-MM-yyyy'}}</td>
                <td *ngIf="cityAssets.installationdate == 0">Date : {{cityAssets.installationdate| date:'dd-MM-yyyy'}}</td>
              </tr>
              <tr>
                <td colspan="2">Contact Person : {{cityAssets.contactperson}}</td>
                <td>Designation : {{cityAssets.contactperson}}</td>
              </tr>
              <tr>
                <td colspan="3">Address &amp; Pin Code :  {{cityAssets.address}}</td>
              </tr>
              <tr>
                <td colspan="2">Tel. No.: {{cityAssets.telno}}</td>
                 </tr>
              <tr>
                <td colspan="3">Work Order for Supply, Installation and FMS 		
        </td>
              </tr>
              <tr>
                <td colspan="2" style="padding: 0px; margin: 0px">
                  <table style="width: 100%" class="table table-bordered print-dc" cellspacing="0px" cellpadding="0px">
                    <tr>
                      <th>Sr.No.</th>
                <th>Items Detail</th>
                <th>Quantity</th>
              </tr>
              <tr *ngFor="let item of cityAssets.installationMasterChild; let i = index ">
                <td>{{i+1}}</td>
                <td>{{item.product}}</td>						
                <td>{{item.count}}</td>	
              </tr>
              </table>
              </td>
              <tr>
                <td colspan="3">Remarks :{{cityAssets.remark}}<br/><br/> </td>
              </tr>
              <tr>
                <td colspan="3">
                  <div class="row">
                  <div class="col-md-12">Date of Installation : <br/><br/><br/><br/><br/></div>
                  <div class="col-md-6">
                    <span class="display-block">----------------------------</span>
                    <span>(Engineer Signature)</span>
                  </div>
                  <div class="col-md-6">
                    <span class="display-block">-----------------------------------------</span>
                    <span>(Customer Name &amp; Signature)</span>
                  </div>
                  </div>
                 </td>
              </tr>
      </table>
    </div>
    <div class="col-sm-2"> 
    <div class="po-action">
        <button *ngIf="!cityAssets.printflag" mat-flat-button color="primary" (click)="printComponent('table');enableUpload(cityAssets.entityId)">
          <mat-icon>print</mat-icon> Print</button>
             <div class="col-sm-12" *ngIf ="cityAssets.uploadflag">
  
              <div class="col-sm-12" >
                  
                  <app-fileupload [files] = "attachmentFiles" maxSize="2048" [entitydata]="cityAssets.entityId" labelname="Upload Attachment" modulename="cityAssets"></app-fileupload>
              </div>
             <button  mat-flat-button color="primary" (click)="disablePrint(cityAssets.entityId)">
           
            <mat-icon>save</mat-icon>
            save</button>
          </div>
        <button  mat-flat-button color="warn" (click)="back()">
          <mat-icon>close</mat-icon>
          Close</button>
      </div>
  
   </div>
  </div>
  </form>